import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { handleLogout, profile } from '../../redux/AuthSlice';
import "./Header.css"
import { useEffect } from 'react';
import { getProfileImage } from '../../helper/Helper';
const pages = [
    {
        path: "/home",
        name: "Home"
    },
    {
        path: "/about-us",
        name: "About Us"
    },
    {
        path: "/contact-us",
        name: "Contact Us"
    }
];
const settings = [
    {
        path: "/profile",
        name: "Profile"
    }
];

function Header() {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const dispatch = useDispatch();
    const { isLoggedIn, profileData } = useSelector((state) => state.authKey);
    const navigate = useNavigate();



    useEffect(() => {
        dispatch(profile());
    }, [isLoggedIn])
    const logOutClick = () => {
        dispatch(handleLogout());
        setAnchorElUser(null);
        navigate("/")
    }
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    const handleCloseUserMenu = () => {
        setAnchorElUser(null);
    };

    return (
        <section className='header'>
            <AppBar position="static">
                <Container maxWidth="xl">
                    <Toolbar disableGutters>
                        <Box
                            component="img"
                            sx={{
                                height: 50,
                                width: 50,
                                display: { xs: 'none', md: 'flex' }
                            }}
                            alt="Logo"
                            src="./assets/image/logo.png"
                        />
                        <Typography
                            variant="h6"
                            noWrap
                            component="a"
                            href="#app-bar-with-responsive-menu"
                            sx={{
                                mr: 2,
                                display: { xs: 'none', md: 'flex' },
                                fontFamily: 'monospace',
                                fontWeight: 700,
                                letterSpacing: '.3rem',
                                color: 'inherit',
                                textDecoration: 'none',
                            }}
                        >

                        </Typography>

                        <Box sx={{ flexGrow: 1, justifyContent: "space-between", display: { xs: 'flex', md: 'none' } }}>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleOpenNavMenu}
                                color="inherit"
                            >
                                <MenuIcon />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorElNav}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'left',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'left',
                                }}
                                open={Boolean(anchorElNav)}
                                onClose={handleCloseNavMenu}
                                sx={{ display: { xs: 'block', md: 'none' }, width: "100%" }}
                            >
                                {pages.map((page) => (
                                    <MenuItem onClick={handleCloseNavMenu} key={page.name}>
                                        <Link to={page.path}>

                                            <Typography sx={{ textAlign: 'center' }} >{page.name}</Typography>

                                        </Link>
                                    </MenuItem>
                                ))}
                                {
                                    isLoggedIn && (
                                        <>
                                            <MenuItem key={'create-product'} onClick={handleCloseNavMenu}>
                                                <Link to={"/create-product"}>

                                                    <Typography sx={{ textAlign: 'center' }} >Create Product</Typography>

                                                </Link>
                                            </MenuItem>
                                            <MenuItem key={'product-list'} onClick={handleCloseNavMenu}>
                                                <Link  to={"/product-list"}>

                                                    <Typography sx={{ textAlign: 'center' }} >Product List</Typography>

                                                </Link>
                                            </MenuItem>

                                        </>


                                    )
                                }
                            </Menu>
                            <Box
                                component="img"
                                sx={{
                                    height: 50,
                                    width: 50,

                                }}
                                alt="Logo"
                                src="./assets/image/logo.png"
                            />
                        </Box>



                        <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
                            {pages.map((page) => (

                                <Link key={page.name} to={page.path}>
                                    <MenuItem>
                                        <Typography sx={{ textAlign: 'center' }} >{page.name}</Typography>
                                    </MenuItem>
                                </Link>


                            ))}
                            {
                                isLoggedIn && (
                                    <>
                                        <Link key={'create-product'} to={"/create-product"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Create Product</Typography>
                                            </MenuItem>
                                        </Link>
                                        <Link key={'product-list'} to={"/product-list"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Product List</Typography>
                                            </MenuItem>
                                        </Link>

                                    </>


                                )
                            }
                        </Box>
                        {/* <Box>
                            {
                                isLoggedIn ? (
                                    <>
                                        <Link to={"/create-product"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Create Product</Typography>
                                            </MenuItem>
                                        </Link>
                                        <Link to={"/product-list"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Product List</Typography>
                                            </MenuItem>
                                        </Link>
                                        <MenuItem onClick={() => dispatch(handleLogout())}>
                                            <Typography sx={{ textAlign: 'center', color: "#fff" }}>Log Out</Typography>
                                        </MenuItem>
                                    </>


                                ) : (
                                    <>

                                        <Link to={"/registration"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Register</Typography>
                                            </MenuItem>
                                        </Link>
                                        <Link to={"/"}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >Login</Typography>
                                            </MenuItem>
                                        </Link>
                                    </>
                                )
                            }

                        </Box> */}
                        <Box sx={{ flexGrow: 0 }}>
                            {
                                isLoggedIn &&

                                <Tooltip title="Open Menu">
                                    <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                                        <Avatar alt="Demy Sharp" src={isLoggedIn && getProfileImage(profileData?.profile_pic)} />
                                    </IconButton>
                                </Tooltip>
                            }
                            <Menu
                                sx={{ mt: '45px' }}
                                id="menu-appbar"
                                anchorEl={anchorElUser}
                                anchorOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorElUser)}
                                onClose={handleCloseUserMenu}
                            >


                                {settings.map((setting) => (
                                    <MenuItem key={setting.path} onClick={handleCloseUserMenu}>
                                        <Link to={setting.path}>
                                            <MenuItem>
                                                <Typography sx={{ textAlign: 'center' }} >{setting.name}</Typography>
                                            </MenuItem>
                                        </Link>
                                    </MenuItem>
                                ))}
                                <MenuItem onClick={logOutClick}>
                                    <Typography sx={{ textAlign: 'center', color: "#fff" }}>Log Out</Typography>
                                </MenuItem>
                            </Menu>
                        </Box>
                    </Toolbar>
                </Container>
            </AppBar >
        </section >
    );
}
export default Header;
